export const create = function (data) {
  let csvString = '';
  for (var i = 0; i < data.length; i++) {
    var rowData = data[i].cells;
    for (var j = 0; j < rowData.length; j++) {
      if (rowData[j].innerHTML.indexOf('span') == -1) {
        csvString = csvString + rowData[j].innerHTML + ",";
      }
    }
    csvString = csvString + "\n";
  }
  return csvString;
}

export const download = function (data) {
  const downloadLink = document.createElement("a");
  downloadLink.download =  new Date + '.csv';
  downloadLink.href = 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(data)))
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
}

export const createSimple = function (data) {
  let csvString = '';
  for (var i = 0; i < data.length; i++) {
    var rowData = data[i];
    csvString = csvString + rowData.number + "," + rowData.value + "," + rowData.power;
    csvString = csvString + "\n";
  }
  return csvString;
}

export default {
  inserted: function (element, binding) {
    element.addEventListener('click', function(){
      const rows = document.querySelectorAll(`${binding.value} tr`);
      const csvString = create(rows);
      download(csvString);
    });
  }
}

